/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 15:11:43
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-09-29 19:29:50
 */
import { isIOS } from '@/utils'
import { service, javaService } from '@/utils/http'

import qs from 'qs'

/**
 * 查询最新版本信息
 * @returns
 */
export function getLaestVserionInfo(params?: any) {
  return javaService.get('/kigo-game-server/version/getLatestVersionInfo', {
    params
  })
}
/**
 * 提交代理申请
 * @param data
 * @returns
 */
export function apiAgentApplySubmit(data: any) {
  return javaService.post('/kigo-game-server/app/agent/submit', data)
}

/**
 * 发送验证码
 * @param data
 * @returns
 */
export function apiAgentSendCode(data: any) {
  return javaService.post('/kigo-user-api/agent/sendCode', data)
}

/**
 * 手机号码注册
 * @param data
 * @returns
 */
export function apiAgentMobileCodeRegister(data: any) {
  return javaService.post('/kigo-user-api/agent/mobileCodeRegister', data, {
    headers: {
      'app-version': '4.8.0',
      platform: 'h5',
      channel: 'daili'
    }
  })
}

/**
 * 微信注册
 * @param data
 * @returns
 */
export function apiAgentWechatRegister(data: any) {
  return javaService.post('/kigo-user-api/agent/wechatRegister', data, {
    headers: {
      'app-version': '4.8.0',
      platform: 'h5',
      channel: 'daili'
    }
  })
}

/**
 * 检测代理是否正常 0 失效 1 正常
 * @param params
 * @returns
 */
export function apiAgentCheckAgent(params: any) {
  return javaService.get('/kigo-game-server/app/agent/checkAgent', { params })
}
